import { computed } from 'vue-demi';
import { Category } from '@ilteducation/content-ref-data-types';
import { useUserContext } from '@ilteducation/ilt-auth';
import useContentRefData from './use-content-ref-data';

const isCategoryVisible = (category?: Category): boolean =>
  // Legacy convention: if icon is NULL, category is hidden
  category !== undefined && category.active && category.icon !== 'NULL';

const useCategories = () => {
  const refDataStore = useContentRefData();
  const userContext = useUserContext();

  const categories = computed(
    () => refDataStore.all('categories').filter((cat) => isCategoryVisible(cat as Category)) as Category[],
  );
  const isLoading = computed(() => refDataStore.isLoading('categories'));
  const byId = computed(() => (id: string) => {
    const cat = refDataStore.byId('categories', id) as Category | undefined;
    return isCategoryVisible(cat) ? cat : undefined;
  });

  const load = (subscriptionType: string) => {
    const filters = [{ key: 'realm', value: [userContext.realm] }];
    if (subscriptionType) {
      filters.push({ key: 'subscriptionTypes', value: [subscriptionType] });
    }
    return refDataStore.references('categories', filters);
  };

  const reset = (subscriptionType: string) => {
    refDataStore.clear();
    return load(subscriptionType);
  };

  // TODO move loading to be done automatically from here?

  return {
    categories,
    byId,
    isLoading,
    load,
    reset,
  };
};

export default useCategories;
